import { FC, useState } from 'react';
import { observer, useNavigate } from '~/modules';
import { Routes } from '~/routes';
import { showAlert, usePolling, useStores } from '~/utils';
import CreditSimulationWithdrawalConfirmation from './CreditSimulationWithdrawalConfirmation';

const CreditSimulationWithdrawalConfirmationContainer: FC = () => {
  const { creditProducts } = useStores();
  const navigate = useNavigate();
  const [isChecking, setIsChecking] = useState(true);
  const [isAuthorizing, setIsAuthorizing] = useState(false);

  const checkPendingWithdrawal = async () => {
    try {
      await creditProducts.getPendingWithdraw();
      setIsChecking(false);
      stopPolling();
    } catch (error) {
      if (error?.status === 404) {
        return;
      }
      showAlert({
        message: error.message || 'Erro ao verificar status do saque',
      });
    }
  };

  const authorizeWithdraw = async () => {
    try {
      setIsAuthorizing(true);
      await creditProducts.confirmWithdrawal();
      navigate(Routes.CREDIT_SIMULATION_SUCCESS);
    } catch (error) {
      showAlert({ message: error.message || 'Erro ao autorizar saque' });
    } finally {
      setIsAuthorizing(false);
    }
  };

  const stopPolling = usePolling({
    pollingFunction: checkPendingWithdrawal,
    interval: 5000,
    executeImmediately: true,
  });

  return (
    <CreditSimulationWithdrawalConfirmation
      isChecking={isChecking}
      isAuthorizing={isAuthorizing}
      authorizeWithdraw={authorizeWithdraw}
      pendingWithdrawal={creditProducts.pendingWithdrawal}
    />
  );
};

export default observer(CreditSimulationWithdrawalConfirmationContainer);
